import React from 'react';

import {SettingsCircleUrl, SettingsResourcePagesEnum} from '../../models/url/settingsUrlModel';
import {SettingsPanelId} from '../../store/panels/panelStateBase';
import {CircleEditorWrapper} from './circleEditorWrapper';
import {CirclesList} from './circlesList';

/*
 * Props.
 */

interface SettingsCirclesProps {
  panelId: SettingsPanelId;
  url: SettingsCircleUrl;
}

/*
 * Component.
 */

export const SettingsCircles: React.FC<SettingsCirclesProps> = (props) => {
  const {url} = props;

  switch (url.resourcePage) {
    case SettingsResourcePagesEnum.OVERVIEW:
      return <CirclesList />;

    case SettingsResourcePagesEnum.EDIT:
    case SettingsResourcePagesEnum.NEW:
      return <CircleEditorWrapper url={url} />;
    default:
      return null;
  }
};
